import { render, staticRenderFns } from "./Schools.vue?vue&type=template&id=bc6332a2&"
import script from "./Schools.vue?vue&type=script&lang=js&"
export * from "./Schools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports